import { gql } from '@apollo/client';
import eventFragment from './eventFragment';
import eventAssignmentsFragment from './eventAssignmentsFragment';

const READY_EVENT = gql`
  mutation ReadyEvent($event: EditEventInput!) {
    readyEvent(event: $event) {
      ...EventFields
      EventAssignments {
        ...EventAssignmentsFields
      }
    }
  }

  ${eventFragment}
  ${eventAssignmentsFragment}
`;

export default READY_EVENT;
